// extracted by mini-css-extract-plugin
module.exports = {"primary":"Button_primary__1mTxz","secondary":"Button_secondary__2t2Od","default":"Button_default__3Zlg-"};